import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "voldemorts-wand",
  name: `Wand - Voldemort`,
  origin: "Harry Potter and the Goblet of Fire",

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
